<div class="card-head pb-3 pt-2">
  <h1>{{ 'orders.Track your order' | translate }}</h1>
</div>
<div class="card-content">

  <div *ngIf='loading' class="dataLoading py-5">
    <mat-spinner class="m-auto" diameter="30"></mat-spinner>
  </div>
  <ng-container *ngIf="!loading">
    <ng-container *ngIf="!details.error">

      <div class="logo-container">
        <img [src]="details.restaurantIcon" alt="">

        <h4 class="mt-2">{{lang == 'ar' ? details.restaurantNameAR : details.restaurantNameEN}}</h4>
      </div>

      <div class="font-18">
        <div class="text-center mb-3">
          <div class="">{{'orders.Order Number' | translate}}</div>
          <div class="font-24 fontMedium">#{{details.orderDetails.orderNumber}}</div>
          <div>{{details.orderDetails.orderDate | date:'EEEE, d MMMM, y'}}</div>
        </div>
        <div class="d-flex justify-content-between">
          <div>
            <!-- {{'orders.Client' | translate}} -->
            <div>{{details.customer.fName + ' ' + details.customer.lName}}</div>
            <div>{{details.customer.phoneCode + ' ' + details.customer.phoneNumber}}</div>
          </div>
          <div>
            {{'receiptBuilder.Amount' | translate}}:
            {{details.orderDetails.total}} {{details.orderDetails.currency.currencyCode}}
          </div>
        </div>

        <ng-container *ngIf="details.orderDetails.cashOnDeliver">
          <hr class="my-3">
          <div class="text-info">
            {{'orders.Please go to the cashier to pay the order so that your order can be processed.' | translate}}
          </div>
        </ng-container>

        <hr class="my-3">

        <div>
          {{'orders.Estimated time to be finished is' | translate}}:
          {{details.orderDetails.preparationTime}} {{'orders.mins' | translate}}
        </div>

        <hr class="my-3">

        <ul class="track-timeline">
          <li *ngFor="let item of details.orderSteps" [class.done]="item.isActive">
            <div class="d-flex align-items-center justify-content-between">
              <span>{{item.stepName}}</span>
              <span>{{item.opreationDate | date:'h:mm a'}}</span>
            </div>
          </li>
        </ul>

      </div>

      <mat-accordion>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>{{'orders.Order Details' | translate}}</mat-panel-title>
          </mat-expansion-panel-header>
          <div>
            <div class="mb-4" *ngFor="let item of details.orderDetails.orderItems">
              <div class="d-flex align-items-center justify-content-between">
                <div>
                  <span>{{item.quantity}}X</span> {{item.itemName}}
                </div>
                <div>{{item.totalItemprice + ' ' + item.curruncyName}}</div>
              </div>
              <div>
                - {{item.sizeName}}
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>

      <div class="order-field" *ngIf="details.orderDetails.orderNotes">
        <h3 class="font-20 fontMedium title d-flex align-items-center">
          <img src="./assets/images/icons/special-request-orange.svg" alt="">
          {{'reservations.Special Request' | translate }}
        </h3>
        <p>{{details.orderDetails.orderNotes}}</p>
      </div>

    </ng-container>

    <div class="py-5 my-5 text-center" *ngIf="details.error">
      <h3>{{details.error?.errorDetail}}</h3>
    </div>


  </ng-container>

</div>
